export enum UserRole {
  FAMILY = 'FAMILY',
  // Educator roles
  AG_TEACHER = 'AG_TEACHER',
  COUNTY_AGENT = 'COUNTY_AGENT',
  DISTRICT_AGENT = 'DISTRICT_AGENT',
  // Show administration
  SHOW_ADMIN = 'SHOW_ADMIN',
  // Platform-level
  STATE_ADMIN = 'STATE_ADMIN',
  IT_MANAGEMENT = 'IT_MANAGEMENT'
}

/** Roles that belong to the Educator portal (Ag Teacher + 4-H sub-roles). */
export const EDUCATOR_ROLES: readonly UserRole[] = [
  UserRole.AG_TEACHER,
  UserRole.COUNTY_AGENT,
  UserRole.DISTRICT_AGENT
];

/**
 * Roles that belong to the Show-Admin portal. STATE_ADMIN is included because
 * the legacy state-admin login backs this portal, and the landing page routes
 * the "State Admin" role card here.
 */
export const SHOW_ADMIN_ROLES: readonly UserRole[] = [UserRole.SHOW_ADMIN, UserRole.STATE_ADMIN];
